// extracted by mini-css-extract-plugin
export default {"social-box":"SocialSharing_social-box__Ls9T7"};